"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M7.76 22.24c-1.54 0-3.07-.58-4.24-1.75a6.011 6.011 0 010-8.49L6.7 8.82l1.41 1.41-3.18 3.18a4.008 4.008 0 000 5.66 4.008 4.008 0 005.66 0l3.18-3.18 1.41 1.41L12 20.49a5.98 5.98 0 01-4.24 1.75zM20.49 12a6.011 6.011 0 000-8.49 6.011 6.011 0 00-8.49 0L8.82 6.7l1.41 1.41 3.18-3.18a4.008 4.008 0 015.66 0 4.008 4.008 0 010 5.66l-3.18 3.18 1.41 1.41L20.49 12zm-4.95-2.12l-1.41-1.41-5.66 5.66 1.41 1.41 5.66-5.66z" }), "LinkAlt");
//# sourceMappingURL=LinkAlt.js.map